// extracted by mini-css-extract-plugin
module.exports = {"status":"InvoiceStatusPlate_status__1UtOi","icon":"InvoiceStatusPlate_icon__3ikxk"};